import {
  GET_SETTING,
  GET_SETTING_SUCCESS,
  GET_SETTING_FAILED,
} from "./actionTypes";

const initialState = {
  settings: {},
  loadingSettings: false,
  error: {
    message: "",
  },
};

const SettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SETTING:
      state = { ...state, loadingSettings: true };
      break;
    case GET_SETTING_SUCCESS:
      state = { ...state, settings: action.payload, loadingSettings: false };
      break;
    case GET_SETTING_FAILED:
      state = {
        ...state,
        error: {
          message: "Error",
        },
        loadingSettings: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SettingReducer;
